// AUTO GENERATED FILE. DO NOT EDIT.
  import PageOrApp from 'tenants/_template/desktop/cua-hang/[providerId]'

  

  
  export default PageOrApp;